const f = {
  color: {
    clay: {
      heading: "#33302eff",
      text: "#574f4bff",
      textBold: "#4a4441ff",
      background: "#faf8f7ff",
      border: "#ede8e6ff"
    },
    charcoal: {
      heading: "#131b24ff",
      text: "#405261ff",
      textBold: "#405261ff",
      background: "#ffffffff",
      border: "#ffffffff"
    }
  },
  squircle: {
    shadow: "drop-shadow(0px 1.05px 1.5px #a270700e) drop-shadow(0px 4.8px 4.22px #a2707016) drop-shadow(0px 12.15px 11.33px #c2b5b514) drop-shadow(0px 24px 26px #a389891a)"
  }
};
export {
  f as blankSlate
};
